// Tailwind removed -> custom CSS classes
// AOS initialized centrally in LandingPage

const JTSS = () => {
  return (
    <div className="section-spacing lp-container">
      <div className="section-header-start">
        <h2 data-aos="fade-up" className="section-title">
          HOW IT WORKS
        </h2>
        <hr data-aos="fade-up" className="section-line" />
      </div>
      <div className="card-grid">
        <div data-aos="fade-up" className="card">
          <h3 className="card-title">Input & Launch</h3>
          <p className="card-text">
            Provide a limited set of key information about the organization and
            its exposed perimeter. No agents, no intrusive deployment, only what
            is strictly necessary to activate the analysis pipeline.
          </p>
        </div>
        <div
          data-aos="fade-up"
          className="card alt-bg-soft"
          style={{ backgroundColor: "#1b8078" }}
        >
          <h3 className="card-title">Automated Quantification</h3>
          <p className="card-text">
            The engine aggregates external exposure data, Dark Web signals and
            threat intelligence, then applies a FAIR-based quantitative model to
            estimate financial loss ranges across realistic attack scenarios.
          </p>
        </div>
        <div data-aos="fade-up" className="card alt-bg-deep">
          <h3 className="card-title">Report Delivery</h3>
          <p className="card-text">
            Within a defined timeframe, you receive a concise, executive-ready
            PDF report presenting exposure levels, financial impact ranges and a
            prioritized set of remediation actions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default JTSS;
